import { useState, type FormEvent } from 'react'
import { Button, Field } from '../design'
import { AuthClientError, type AuthClient } from './client'
import { AUTH_COPY, SIGN_IN_COPY } from './copy'

export const SignInPage = ({ auth }: { auth: AuthClient }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [pending, setPending] = useState(false)

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setPending(true)
    setError(null)
    try {
      await auth.signIn(email, password)
    } catch (caught: unknown) {
      setError(caught instanceof AuthClientError ? caught.message : AUTH_COPY.unknown)
    } finally {
      setPending(false)
    }
  }

  return (
    <div className="entry sign-in">
      <div className="entry-band hatch" aria-hidden="true" />
      <main className="entry-sheet">
        <h1 className="sign-in-title">{SIGN_IN_COPY.title}</h1>
        <p className="sign-in-subtitle">{SIGN_IN_COPY.subtitle}</p>
        <form className="sign-in-form" onSubmit={(event) => void submit(event)} noValidate>
          <Field id="sign-in-email" label={SIGN_IN_COPY.email}>
            {({ id }) => (
              <input
                id={id}
                type="email"
                autoComplete="username"
                inputMode="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            )}
          </Field>
          <Field id="sign-in-password" label={SIGN_IN_COPY.password}>
            {({ id }) => (
              <input
                id={id}
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            )}
          </Field>
          {error === null ? null : (
            <p className="sign-in-error tone-danger" role="alert">
              {error}
            </p>
          )}
          <Button type="submit" variant="primary" size="large" pending={pending} pendingLabel={SIGN_IN_COPY.submitting}>
            {SIGN_IN_COPY.submit}
          </Button>
        </form>
      </main>
    </div>
  )
}
